// Словарь маркеров анализа интенсивности тем с русскими названиями и типами
export const topicsIntensityMarkersDictionary = {
  // Основные данные
  'time_stamp': { label: 'Временная метка', isNumeric: false, isHidden: true, isSystem: true },
  'session_id': { label: 'ID сессии', isNumeric: false, isHidden: true, isSystem: true },
  'group_id': { label: 'Группа', isNumeric: false, isHidden: true },
  'post_id': { label: 'ID поста', isNumeric: false, isHidden: true },
  'author_id': { label: 'ID автора', isNumeric: false, isHidden: true },
  'date': { label: 'Дата', isNumeric: false, isHidden: true },
  'text': { label: 'Текст', isNumeric: false },
  'text_cleaned': { label: 'Очищенный текст', isNumeric: false },
  
  // Анализ интенсивности
  'dict': { label: 'Словарь', isNumeric: false },
  'intensity': { label: 'Интенсивность', isNumeric: true },
};

// Функция для получения русского названия маркера
export const getTopicsIntensityMarkerLabel = (markerKey) => {
  const marker = topicsIntensityMarkersDictionary[markerKey];
  return marker ? marker.label : markerKey;
};

// Функция для проверки, является ли маркер числовым
export const isNumericTopicsIntensityMarker = (markerKey) => {
  const marker = topicsIntensityMarkersDictionary[markerKey];
  return marker ? marker.isNumeric : false;
};

export const isTopicsIntensityMarkerHidden = (markerKey) => {
  const marker = topicsIntensityMarkersDictionary[markerKey];
  return marker ? marker.isHidden : false;
};

export const isTopicsIntensityMarkerSystem = (markerKey) => {
  const marker = topicsIntensityMarkersDictionary[markerKey];
  return marker ? marker.isSystem : false;
};

// Категории маркеров анализа интенсивности тем
export const topicsIntensityMarkerCategories = [
  {
    category: 'Основные данные',
    markers: ['time_stamp', 'session_id', 'group_id', 'post_id', 'author_id', 'date', 'text', 'text_cleaned']
  },
  {
    category: 'Анализ интенсивности',
    markers: ['dict', 'intensity']
  }
]; 